module.exports = __webpack_public_path__ + "static/media/Logo.ee9c9a6a.svg";